import { default as Button } from './Button';

export default Button;
